import React from "react";
import Grid from "@mui/material/Grid";
import { translate } from "../../../../services/Translations/translatorService";
import IconButton from "@mui/material/IconButton";
import { Call } from "@mui/icons-material";
import { TextField } from "@mui/material";
import contactStyle from "./contactStyle";
import ContentBox from "../../../ContentBox/ContentBox";

import { ProductUnion } from "../../../../types/ProductUnion";

type ContactProps = {
  product: ProductUnion;
};

const Contact = ({ product }: ContactProps) => {
  return (
    <ContentBox headline="Kontakt">
      <Grid container sx={{
        alignItems: "flex-start"
      }}>
        <Grid size={10}>
          <TextField
            disabled={true}
            value={product.customer?.telephone}
            label={translate("customer.telephone.label")}
          />
        </Grid>
        <Grid sx={contactStyle.callGridItem} size={2}>
          <IconButton
            color={"secondary"}
            sx={contactStyle.callIcon}
            href={"tel:" + product.customer?.telephone}
            disabled={!product.customer?.telephone}
            size="large"
          >
            <Call />
          </IconButton>
        </Grid>
        <Grid size={10}>
          <TextField
            disabled={true}
            value={product.customer?.alternativeTelephone}
            label={translate("customer.alternativeTelephone.label")}
          />
        </Grid>
        <Grid sx={contactStyle.callGridItem} size={2}>
          <IconButton
            color={"secondary"}
            sx={contactStyle.callIcon}
            href={"tel:" + product.customer?.alternativeTelephone}
            disabled={!product.customer?.alternativeTelephone}
            size="large"
          >
            <Call />
          </IconButton>
        </Grid>
      </Grid>
    </ContentBox>
  );
};

export default Contact;
